<template>
     <transition name="overlay" >
    <!--<transition name="transition&#45;&#45;fullpage" :duration="{ enter: 2500, leave: 2500 }">-->
        <div class="modal-backdrop">
            <div class="modal-transition-effect"></div>

            <div class="modal modal--fullpage">
                <section class="modal-header">
                    <div class="container container--nav">
                        <a href="/"><div class="logo"></div></a>                
                        <div class="close" @click="close"></div>
                    </div>
                </section>
                <section class="modal-content">
                    <div class="container--body container">
                        <slot name="content"></slot>
                    </div>
                </section>
            </div>

        </div>
    </transition>
</template>

<script>
export default {
    name: 'modal-fullpage',
    props: {
        data: {
            type: Object
        }
    },
    methods: {
        close() {
            const body = document.body;
            body.classList.remove("fs-modal-visible");
            
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";
    @import "../../../scss/abstracts/mixins";

    .modal-backdrop {
        background-color: #c4dcee;
    }

    .modal--fullpage { 
        .modal-header {
            .container--nav {
                height: 82px;

                @media #{$xl} {
                    height: 130px;
                }

                .logo {
                    margin: 0;
                    height: 50px;
                    width: 214px;

                    @media #{$xl} {
                        height: 65px;
                        width: 280px;
                    }
                }

                .close {
                    right: 15px;
                    top: 1.5rem;

                    @media #{$sm} {
                        right: calc(2.0833333333vw - 9px);
                    }

                    @media #{$xl} {
                        top: 3rem;
                    }
                }
            }
        }

        .modal-content {
            padding: 82px 0 0;

            @media #{$xl} {
                padding: 130px 0 0;
            }
        }
    }
</style>

<style lang="scss">
body {
    &.fs-modal-visible {
        overflow: hidden;

        .profile-links {
            display: none;
        }
    }
}
</style>